export default {
  pageTitle: "Events",
  welcome: "Welcome ",
  date: "Date",
  name: "Event Name",
  image: "Image",
  timezone: "Timezone",
  add: "+ Event",
  blankMessage: "No events.",
  singleMessage:
    "You currently have the Single Plan. You can add one event. To add more events upgrade your plan.",
  basicMessage:
    "You are currently subscribed to the Basic Plan. You can add one event. To add more events upgrade your plan.",
  standardMessage:
    "You are currently subscribed to the Standard Plan. You can add 3 events. To add more events upgrade your plan.",
  premierMessage:
    "You are currently subscribed to the Premier Plan. You can add unlimited events. ",
  mobileMessage:
    "View your account on the web to manage and enable more events or collaborators.",
};



// WEBPACK FOOTER //
// ./src/views/user/projects/Projects.messages.js